import React from "react";
import MainImg from "../../../Assets/Home/officedecor.png";
import MainOneImg from "../../../Assets/Home/shop.png";
import MaintwoImg from "../../../Assets/Home/offcard.png";
import offerCard from "../../../Assets/Home/decor.png";

const Offer = () => {
  return (
    <div className="w-full bg-white flex flex-col md:flex-row justify-center items-stretch gap-6 px-4 md:px-10 pb-10">
      {/* Left main image */}
      <div className="flex justify-center items-center w-full md:w-1/4">
        <img
          src={MainImg}
          alt="Main Offer"
          className="w-full h-[500px] object-cover rounded-xl shadow-md"
        />
      </div>

      {/* Middle column */}
      <div className="flex flex-col justify-between gap-6 w-full md:w-1/4">
        <img
          src={MainOneImg}
          alt="Offer 1"
          className="w-full h-[240px] object-cover rounded-xl shadow-md"
        />
        <img
          src={MaintwoImg}
          alt="Offer 2"
          className="w-full h-[240px] object-cover "
        />
      </div>

      {/* Right main image */}
      <div className="flex justify-center items-center w-full md:w-1/4">
        <img
          src={offerCard}
          alt="Main Offer 2"
          className="w-full h-[500px] object-cover rounded-xl shadow-md"
        />
      </div>

      {/* Rightmost column */}
      <div className="flex flex-col justify-between gap-6 w-full md:w-1/4">
        <img
          src={MaintwoImg}
          alt="Offer 3"
          className="w-full h-[240px] object-cover "
        />
        <img
          src={MainOneImg}
          alt="Offer 4"
          className="w-full h-[240px] object-cover rounded-xl shadow-md"
        />
      </div>
    </div>
  );
};

export default Offer;
